<template>
    <div class="map">
        <img :src="map" alt="" style="width: 100%;height: 100%">
        <div class="country_map">
            <div v-for="(item, index) in country_list" :key="index" class="country"
                 :style="{left:item.x+'%',top:item.y+'%'}">
                <img style="height: 70%"
                     :src="`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/${item.country_code.toLocaleLowerCase()}.svg`"
                     alt="">
                <span class="count">¥{{
                        item.order_amount
                    }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import map from "@/assets/images/map.png";


export default {
	name: "map-a",
	data() {
		return {
			map: map, country_list: [], show: true
		}
	},
	methods: {
		format() {
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		},
		setCountryList(data) {
			this.country_list = data.map(item => {
				item.order_amount = this.format().format(item.order_amount)
				return {
					...item,

				}
			})
		}
	}
}
</script>

<style scoped lang="less">
@keyframes blinkAnimation {
  0% {
    opacity: 0.35;
  }
  //25% {
  //  opacity: 0.5;
  //}
  50% {
    opacity: 1;
  }
  //75% {
  //  opacity:0.5;
  //}
  /* 存在 3s */
  100% {
    opacity: 0.35;
  }
  /* 消失 1s */
}

.country {
  animation: blinkAnimation 5s infinite;
}

.country_map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .count {
    color: #e4ac3e;
    font-size: 0.36rem;
    margin-left: 5px;
    font-style: italic;
  }
}
</style>
